import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../api";
import { useAuth } from "../auth";
import { Card, Spinner } from "../components/ui";

export default function VerifyPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [status, setStatus] = useState<"working" | "ok" | "fail">("working");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setStatus("fail");
      setError("Missing sign-in token.");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/verify", { token });
        await refresh();
        setStatus("ok");
        setTimeout(() => navigate("/", { replace: true }), 600);
      } catch (err) {
        setStatus("fail");
        setError((err as Error).message);
      }
    })();
  }, [params, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <Card accent>
          <div className="flex flex-col items-center gap-4 py-4">
            {status === "working" && (
              <>
                <Spinner size={28} />
                <p className="text-plum-soft">Signing you in…</p>
              </>
            )}
            {status === "ok" && (
              <>
                <div className="w-12 h-12 rounded-full bg-blush-soft flex items-center justify-center text-rose-dark">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path d="M5 12l4 4L19 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <p className="font-serif text-xl">Welcome back.</p>
              </>
            )}
            {status === "fail" && (
              <>
                <div className="w-12 h-12 rounded-full bg-blush-soft flex items-center justify-center text-rose-dark">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path d="M12 8v5M12 17.01V17M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                  </svg>
                </div>
                <p className="font-serif text-xl">Sign-in failed</p>
                <p className="text-sm text-plum-soft text-center">{error}</p>
                <Link to="/login" className="text-sm text-rose underline">
                  Request a new link
                </Link>
              </>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
}
